import * as React from "react";

function SvgTaplytics(props, ref) {
  return (
    <svg
      id="Taplytics_svg__Layer_1"
      x={0}
      y={0}
      viewBox="65 24 251.5 255"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Taplytics_svg__st1{fill:#7696ee}"}</style>
      <path fill="#fff" d="M84.6 63h222.5v179H84.6z" />
      <path
        className="Taplytics_svg__st1"
        d="M75.9 245.9h239.8V59.1H75.9v186.8zm8.7-178h222.5v169.2H84.6V67.9z"
      />
      <path
        className="Taplytics_svg__st1"
        d="M123.8 132.1h33.4v65.8h25.3v-90.8h-58.7v25zm110.7-25h-25.3v90.8h58.7V173h-33.4v-65.9z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgTaplytics);
